import { el, fmt, LABELS } from './dom.js';
import { bandFor } from './package-history.js';

function period(group) {
  return group.firstPurchasedAt === group.lastPurchasedAt ? fmt.date(group.firstPurchasedAt) : `${fmt.date(group.firstPurchasedAt)} – ${fmt.date(group.lastPurchasedAt)}`;
}

function contributorsText(group) {
  const players = group.contributors === 1 ? '1 jogador registrou' : `${fmt.int(group.contributors)} jogadores registraram`;
  return group.records > group.contributors ? `${players} esta oferta (${fmt.int(group.records)} registros).` : `${players} esta oferta.`;
}

// Melhores ofertas: registros equivalentes contam uma única vez (média do grupo).
export function renderPackageRanking(host, items, stats) {
  if (!items.length) return host.replaceChildren(el('p', { className: 'mc-empty', text: 'Nenhuma oferta com Crons registrada neste período.' }));
  host.replaceChildren(el('table', { className: 'mc-table mc-ranking-table' }, [
    el('thead', {}, [el('tr', {}, ['#', 'Pacote', 'Data', 'Registros', 'Cron/Pérola'].map((label) => el('th', { scope: 'col', text: label })))]),
    el('tbody', {}, items.map((group, index) => {
      const band = bandFor(group.averageCronPerPearl, stats);
      return el('tr', {}, [
        el('td', { className: 'mc-rank', text: String(index + 1) }),
        el('td', { className: 'mc-cell-name' }, [el('strong', { text: group.packageName }), el('small', { text: `${fmt.int(group.averageEffectivePearls)} Pérolas · ${LABELS.regions[group.region] || group.region}` })]),
        el('td', { 'data-label': 'Data', text: period(group) }),
        el('td', { 'data-label': 'Registros', className: 'num', text: fmt.int(group.records) }),
        el('td', { 'data-label': 'Cron/Pérola', className: 'num' }, [el('span', { className: `mc-cpp mc-band-${band}`, text: fmt.cpp(group.averageCronPerPearl) })])
      ]);
    }))
  ]));
}

// Ofertas agrupadas: vários jogadores cadastrando o mesmo pacote viram
// conhecimento coletivo, sem apagar nenhum registro individual.
export function renderPackageGroups(host, items, stats, { onSearch }) {
  if (!items.length) return host.replaceChildren(el('p', { className: 'mc-empty', text: 'Nenhuma oferta encontrada.' }));
  host.replaceChildren(...items.map((group) => {
    const band = bandFor(group.averageCronPerPearl, stats);
    return el('article', { className: 'mc-group-card' }, [
      el('div', { className: 'mc-group-head' }, [
        el('span', { className: 'mc-kind', text: `${LABELS.packageTypes[group.packageType] || 'Pacote'} · ${LABELS.regions[group.region] || group.region}` }),
        group.communityConfirmed ? el('span', { className: 'mc-confirmed', text: '✓ Dados confirmados pela comunidade' }) : null
      ]),
      el('h3', { text: group.packageName }),
      el('p', { className: 'mc-muted', text: `${period(group)} · ${fmt.int(group.originalPrice)} Pérolas (preço cheio)` }),
      el('p', { text: contributorsText(group) }),
      el('dl', { className: 'mc-group-stats' }, [
        el('div', {}, [el('dt', { text: 'Cron/Pérola médio' }), el('dd', {}, [el('span', { className: `mc-cpp mc-band-${band}`, text: fmt.cpp(group.averageCronPerPearl) })])]),
        el('div', {}, [el('dt', { text: 'Menor' }), el('dd', { text: fmt.cpp(group.minCronPerPearl) })]),
        el('div', {}, [el('dt', { text: 'Maior' }), el('dd', { text: fmt.cpp(group.maxCronPerPearl) })])
      ]),
      el('button', { type: 'button', className: 'mc-link-button', text: 'Ver registros no histórico', onclick: () => onSearch(group.packageName) })
    ]);
  }));
}
